import React, { useEffect, createElement } from 'react';
const META_NAME = 'facebook-domain-verification';
const META_CONTENT = 'fsfg8nc0exsr8pygv0lhmbom57bz75';
/**
 * Injects the Facebook domain-verification <meta> tag into <head>.
 *
 * Magic Patterns does not expose a static index.html to edit, so this is
 * the standard SPA pattern: the meta tag is appended to document.head
 * at app mount. Meta's crawler executes JS and will read the tag the
 * same way it would read a statically-rendered one.
 */
export function FacebookDomainVerification() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // Guard against duplicate insertion if the effect ever re-runs
    if (document.querySelector(`meta[name="${META_NAME}"]`)) return;
    const meta = document.createElement('meta');
    meta.setAttribute('name', META_NAME);
    meta.setAttribute('content', META_CONTENT);
    document.head.appendChild(meta);
  }, []);
  return null;
}